(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-save-email"] && !Shopify.designMode) return;
  try {
    /**
 * Cart "email me my basket" capture. See snippets/cart-save-email.liquid. Added 10 Oct 2026.
 */
if (!customElements.get('cart-save-email')) {
  class CartSaveEmail extends HTMLElement {
    connectedCallback() {
      this.querySelector('.cart-save-email__form')?.addEventListener('submit', (e) => this.submit(e));
      this.querySelector('.cart-save-email__details')?.addEventListener('toggle', () => { this.openedAt = Date.now(); });
    }

    done(form) {
      form.hidden = true;
      this.querySelector('.cart-save-email__success').hidden = false;
    }

    async submit(event) {
      event.preventDefault();
      const form = event.currentTarget;
      const input = this.querySelector('.cart-save-email__input');
      const button = this.querySelector('.cart-save-email__submit');
      const errorEl = this.querySelector('.cart-save-email__error');
      const email = (input?.value || '').trim();
      const wantsNews = !!this.querySelector('.cart-save-email__optin-box')?.checked;
      errorEl.hidden = true;

      // Bot checks: hidden trap field filled, or submitted faster than a person could type.
      const trap = form.querySelector('input[name="website"]');
      if ((trap && trap.value) || (this.openedAt && Date.now() - this.openedAt < 2500)) {
        this.done(form);
        return;
      }

      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        errorEl.textContent = this.dataset.msgInvalid;
        errorEl.hidden = false;
        input?.focus();
        return;
      }

      const base = 'https://a.klaviyo.com/client';
      const key = this.dataset.klaviyoPublicKey;
      const headers = { 'Content-Type': 'application/json', revision: '2024-10-15' };
      button.disabled = true;
      try {
        // 1. The basket email the visitor asked for (no marketing consent implied).
        const response = await fetch(`${base}/events/?company_id=${key}`, {
          method: 'POST',
          headers,
          body: JSON.stringify({
            data: {
              type: 'event',
              attributes: {
                properties: { basket_path: this.dataset.basketPath, source: 'cart drawer' },
                metric: { data: { type: 'metric', attributes: { name: 'Saved Basket Requested' } } },
                profile: { data: { type: 'profile', attributes: { email } } }
              }
            }
          })
        });

        // 2. Marketing, only when the box is ticked.
        if (wantsNews) {
          await fetch(`${base}/subscriptions/?company_id=${key}`, {
            method: 'POST',
            headers,
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  custom_source: 'Cart drawer: news box ticked',
                  profile: { data: { type: 'profile', attributes: { email } } }
                },
                relationships: { list: { data: { type: 'list', id: this.dataset.klaviyoListId } } }
              }
            })
          });
        }

        if (response.status === 202 || response.ok) {
          this.done(form);
          try { window.klaviyo?.identify?.({ email }); } catch (e) { /* ignore */ }
        } else {
          errorEl.textContent = this.dataset.msgError;
          errorEl.hidden = false;
        }
      } catch (e) {
        errorEl.textContent = this.dataset.msgError;
        errorEl.hidden = false;
      } finally {
        button.disabled = false;
      }
    }
  }
  customElements.define('cart-save-email', CartSaveEmail);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["group"] && !Shopify.designMode) return;
  try {
    class GroupSlider {
    constructor(element) {
      this.slider = element;
      this.track = element.querySelector('.group-slider__track');
      this.prevBtn = element.querySelector('[data-slider-prev]');
      this.nextBtn = element.querySelector('[data-slider-next]');
      this.currentIndex = 0;
      this.items = Array.from(this.track.children);
      this.autoplayEnabled = element.dataset.groupSliderAutoplay === 'true';
      this.autoplayDelay = Number(element.dataset.groupSliderAutoplaySpeed) || 5000;
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.autoplayTimer = null;
      this.autoplayPauseReasons = new Set();

      this.init();
    }

    init() {
      if (!this.items.length) return;

      // Set initial opacity for all items
      this.items.forEach((item, index) => {
        item.style.transition = 'opacity 0.75s ease-in-out';
        item.style.opacity = index === 0 ? '1' : '0';
      });

      this.prevBtn.addEventListener('click', () => this.prev(true));
      this.nextBtn.addEventListener('click', () => this.next(true));

      // event listeners for swipe gestures
      let startX = 0;
      let endX = 0;
      this.slider.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
      });
      this.slider.addEventListener('touchend', (e) => {
        endX = e.changedTouches[0].clientX;
        const diffX = endX - startX;
        if (Math.abs(diffX) > 50) { // threshold
          if (diffX > 0) {
            this.prev(true);
          } else {
            this.next(true);
          }
        }
      });

      this.setupAutoplay();


      // Wait for initial render then set height without animation, then lock overflow
      requestAnimationFrame(() => {
        this.slider.style.transition = 'none';
        this.updateHeight(this.currentIndex);
        this.slider.style.overflowY = 'hidden';
        requestAnimationFrame(() => {
          this.slider.style.transition = '';
        });
      });
    }

    setupAutoplay() {
      if (!this.autoplayEnabled || this.prefersReducedMotion || this.items.length < 2) return;

      this.slider.addEventListener('mouseenter', () => this.pauseAutoplay('hover'));
      this.slider.addEventListener('mouseleave', () => this.resumeAutoplay('hover'));
      this.slider.addEventListener('focusin', () => this.pauseAutoplay('focus'));
      this.slider.addEventListener('focusout', () => this.resumeAutoplay('focus'));
      this.slider.addEventListener('touchstart', () => this.pauseAutoplay('touch'), { passive: true });
      this.slider.addEventListener('touchend', () => this.resumeAutoplay('touch'));

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          this.pauseAutoplay('visibility');
          return;
        }
        this.resumeAutoplay('visibility');
      });

      this.startAutoplay();
    }

    startAutoplay() {
      if (this.autoplayTimer || this.autoplayPauseReasons.size > 0) return;

      this.autoplayTimer = window.setInterval(() => {
        this.next();
      }, this.autoplayDelay);
    }

    stopAutoplay() {
      if (!this.autoplayTimer) return;

      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }

    pauseAutoplay(reason) {
      if (!this.autoplayEnabled || this.prefersReducedMotion) return;

      this.autoplayPauseReasons.add(reason);
      this.stopAutoplay();
    }

    resumeAutoplay(reason) {
      if (!this.autoplayEnabled || this.prefersReducedMotion) return;

      this.autoplayPauseReasons.delete(reason);
      this.startAutoplay();
    }

    resetAutoplay() {
      if (!this.autoplayEnabled || this.prefersReducedMotion) return;

      this.stopAutoplay();
      this.startAutoplay();
    }

    next(isUserInteraction = false) {
      this.currentIndex = (this.currentIndex + 1) % this.items.length;
      this.updateSlider();

      if (isUserInteraction) {
        this.resetAutoplay();
      }
    }

    prev(isUserInteraction = false) {
      this.currentIndex = (this.currentIndex - 1 + this.items.length) % this.items.length;
      this.updateSlider();

      if (isUserInteraction) {
        this.resetAutoplay();
      }
    }

    updateHeight(index) {
      const currentItem = this.items[index];
      if (!currentItem) {
        return;
      }

      // Clone the item to measure its natural height without flex constraints
      const clone = currentItem.cloneNode(true);
      clone.style.position = 'absolute';
      clone.style.visibility = 'hidden';
      clone.style.width = currentItem.offsetWidth + 'px';
      clone.style.height = 'auto';
      clone.style.flex = 'none';
      clone.style.opacity = '1';

      this.slider.appendChild(clone);

      // Force reflow
      void clone.offsetHeight;

      // Get natural height
      const naturalHeight = clone.offsetHeight;
      const cloneStyle = window.getComputedStyle(clone);
      const marginTop = parseFloat(cloneStyle.marginTop) || 0;
      const marginBottom = parseFloat(cloneStyle.marginBottom) || 0;

      // Remove clone
      this.slider.removeChild(clone);

      const totalHeight = naturalHeight + marginTop + marginBottom;

      // Update slider height
      this.slider.style.height = `${totalHeight + 44}px`;
    }

    updateSlider() {
      const offset = -this.currentIndex * 100;

      // Fade out all items
      this.items.forEach((item) => {
        item.style.opacity = '0';
      });

      // Wait for fade out, then slide
      setTimeout(() => {
        this.track.style.transform = `translateX(${offset}%)`;

        // Update height to match the new current item
        requestAnimationFrame(() => {
          this.updateHeight(this.currentIndex);

          // Fade in current item
          this.items[this.currentIndex].style.opacity = '1';
        });
      }, 300);
    }
  }

  document.querySelectorAll('[data-group-slider]').forEach(slider => {
    new GroupSlider(slider);
  });
  } catch(e) { console.error(e); }
})();

})();
